import React from "react";
import styles from "../../styles/components/listDropdownforemptwin.module.scss";

export default function indexemptwin(props) {

const [ keepTrack, setKeepTrack ] = React.useState([])

React.useEffect(() => {
 
  console.log(props.presentState, "presentState")
  if (props.presentState != null && props.presentState != undefined && props.presentState.length != 0 ){
    let previousVStateAr = []
     props.presentState.map((previousItem,index) => {
      
       props.values.map((item, index) => {
         console.log(previousItem, item, "========>itemsspreviousitems")
         if (previousItem == item) {
           previousVStateAr.push(index)
          
         }
       }
       )
      
     })
     setKeepTrack([...previousVStateAr])
  }
}, [])

const checkChange = (option, index,e) => {



  // if (option == "No parent Selected")
  //   {
  //     return; 
  //   }




    if (e.target.checked) 
     {
     console.log(keepTrack, "========>keepTrack", index)
     setKeepTrack([...keepTrack, index])
     if(props.dropdownParent=="mco"){
       let arr=[...props.presentState] 
             console.log("========>mco i",arr)
             arr.push(option)
             console.log("========>mco im",arr)
             console.log("========>mco im2",props.presentState)
      props.getDropdownValue(arr, props.dropdownParent, props.haveRelated, true);
     }else{
      let arr=[...props.presentState] 
      arr.push(option)
      console.log("========>mco im",arr)
      console.log("========>mco im2",props.presentState)
       props.getDropdownValue(option, props.dropdownParent, props.haveRelated, true);
     }
    }

    else {
     let newKeepTrack = keepTrack.filter((item) => item != index)
     setKeepTrack([...newKeepTrack])
     props.removeCheckedValue(option, props.dropdownParent, props.haveRelated)
    }
}



React.useEffect(() => {
    console.log(keepTrack, "this is what you ")
}, [keepTrack])
  return (
    <div className={styles.listContainer}>

{props.values.map((option, index) => (
            // <li onClick={() => optionSelected(option)}>{option}</li> // give a color on hover , make curson pointer,
            <label className={styles.list_Checkbox_container}>
            <span className={styles.lableHead}>{option}</span>
            {
              option == "No parent Selected" ?
               null :
              <input type="checkbox" onChange = { (e) => checkChange(option, index, e)} checked = {keepTrack.includes(index) ? true : false}/>
              }
              <span className={styles.list_checkmark}></span>
            </label>
          ))}
     


{/* 
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
        <span className={styles.lableHead}>One</span>
        <input type="checkbox" checked="checked" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
        <span className={styles.lableHead}>One</span>
        <input type="checkbox" checked="checked" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
        <span className={styles.lableHead}>One</span>
        <input type="checkbox" checked="checked" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label>
      <label className={styles.list_Checkbox_container}>
      <span className={styles.lableHead}>One</span>
        <input type="checkbox" />
        <span className={styles.list_checkmark}></span>
      </label> */}
    </div>
  );
}

